import script from "./investigation.vue?vue&type=script&setup=true&lang=js"
export * from "./investigation.vue?vue&type=script&setup=true&lang=js"

import "./investigation.vue?vue&type=style&index=0&id=6a33885f&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a33885f"]])

export default __exports__